import { render, staticRenderFns } from "./LoginSSOView.vue?vue&type=template&id=11c049c6&scoped=true"
import script from "./LoginSSOView.vue?vue&type=script&lang=js"
export * from "./LoginSSOView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c049c6",
  null
  
)

export default component.exports